<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header>
          <h1>Transferência em Lote</h1>
          <small>
            * A transferência em lote é possível somente entre turmas de mesma
            disciplina, mesmo turno e mesma filial.
          </small>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row>
          <vs-col>
            <h3 class="tituloForm">Informe o IdTurmaDisc de Origem</h3>
            <vs-input
              name="originSubjectId"
              type="number"
              v-model="originSubjectId"
              @keyup.enter="searchStudents(originSubjectId)"
            />
          </vs-col>
          <vs-col v-if="hasStudents">
            <h3 class="tituloForm">Dados da Turma</h3>
            <p>
              ({{ studentsList[0].CODTURMA }}) - {{ studentsList[0].DISCIPLINA }},
              FILIAL {{ studentsList[0].CODFILIAL }} - {{ studentsList[0].TURNO }}
            </p>
          </vs-col>
        </vs-row>

        <vs-row v-if="hasStudents">
          <vs-col>
            <h3 class="tituloForm">Selecione a turma destino</h3>
            <vs-select
              placeholder="Selecione"
              noData="Nenhum dado encontrado"
              v-model="destinationSelected"
              autocomplete
              width="100%"
            >
              <vs-select-item
                v-for="destination in destinationOptions"
                :key="destination.IDTURMADISC"
                :value="destination"
                :text="destination.NOMENCLATURAVAGAS"
              >
              </vs-select-item>
            </vs-select>
          </vs-col>

          <vs-col>
            <h3 class="tituloForm">Motivo da transferência</h3>
            <vs-select
              v-model="movementReasonSelected"
              danger-text="Campo obrigatório."
              placeholder="Selecione"
              noData="Nenhum dado encontrado"
              width="100%"
              autocomplete
            >
              <vs-select-item
                v-for="reason in movementReasons"
                :key="reason.CODMOTIVO"
                :value="reason.CODMOTIVO"
                :text="reason.DESCRICAO"
              >
              </vs-select-item>
            </vs-select>
          </vs-col>
        </vs-row>

        <vs-row v-if="hasStudents">
          <vs-col>
            <h3 class="tituloForm">
              Selecione os estudantes que deseja transferir
            </h3>
            <p class="small">
              Estudantes selecionados: {{ studentsToTransfer.length }}
            </p>

            <vs-table
              class="pd-table"
              :data="studentsList"
              v-model="studentsToTransfer"
              multiple
              pagination
              max-items="50"
              search
            >
              <template slot="thead">
                <th>RA</th>
                <th>Nome</th>
                <th>Curso</th>
                <th>Obs.</th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" v-for="(tr, indexTr) in data" :key="indexTr">
                  <vs-td>{{ data[indexTr].RA }}</vs-td>
                  <vs-td>{{ data[indexTr].ALUNO }}</vs-td>
                  <vs-td>{{ data[indexTr].CURSO }}</vs-td>
                  <vs-td>{{ data[indexTr].INADIMPLENTE }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col>
            <vs-button
              style="width: 100%;"
              icon="check_circle"
              @click="executeTransfer()"
              color="#139B0E"
              type="filled"
              v-if="studentsToTransfer.length > 0 && destinationSelected"
            >
              Realizar Transferência
            </vs-button>
          </vs-col>
        </vs-row>

        <vs-popup title="Processo de Transferência em Lote" :active.sync="error">
          <vs-row>
            <p class="error">{{ message }}</p>
          </vs-row>
        </vs-popup>

        <vs-popup
          title="Resultado do Processo de Transferência em Lote"
          :active.sync="resultProcess"
        >
          <vs-row
            ><vs-col
              ><p
                v-for="(student, index) in studentsToTransferResult"
                :key="index"
                :class="student.class"
              >
                {{ student.RA }} - {{ student.ALUNO }} - {{ student.result }}
              </p>
            </vs-col>
          </vs-row>
        </vs-popup>
      </section>
    </div>
  </div>
</template>

<script>
import AcademicMovement from "../services/academicMovements";
export default {
  name: "BatchTransfer",
  data: () => ({
    originSubjectId: "",
    studentsList: [],
    hasStudents: false,
    studentsToTransfer: [],
    studentsToTransferResult: [],
    destinationOptions: [],
    error: false,
    destinationSelected: null,
    movementReasonSelected: null,
    movementReasons: null,
    resultProcess: false,
    message: "",
  }),
  methods: {
    async searchStudents(originSubjectId) {
      this.studentsToTransfer = [];
      this.destinationSelected = null;
      this.destinationOptions = [];
      this.error = false;
      this.message = "";
      this.studentsList = [];
      this.hasStudents = false;

      this.$vs.loading({
        color: "danger",
      });
      await new AcademicMovement()
        .getStudentsBySubjectId(originSubjectId)
        .then((response) => {
          let data = response.data;
          this.studentsList = Array.isArray(data) ? data : [data];
          if (this.studentsList[0] != "") this.hasStudents = true;
          else {
            this.error = true;
            this.message =
              "Não foram encontrados alunos aptos para transferência na turma informada, ou a turma informada não existe.";
          }
        })
        .catch(({ error }) => {
          this.error = error;
        })
        .finally(() => {
          this.$vs.loading.close();
        });

      if (this.studentsList[0] != "") {
        this.$vs.loading({
          color: "danger",
        });
        await new AcademicMovement()
          .getDestinationOptions(
            originSubjectId,
            this.studentsList[0].IDHABILITACAOFILIALTURMA,
            0
          )
          .then(({ data }) => {
            this.destinationOptions = Array.isArray(data) ? data : [data];
            if (this.destinationOptions[0] == "") {
              this.destinationOptions = [];
              this.error = true;
              this.message =
                "Não foram localizadas turmas disponíveis para transferir os alunos";
            }
          })
          .catch(({ error }) => {
            console.log(error);
          })
          .finally(() => {
            this.$vs.loading.close();
          });

        this.$vs.loading({
          color: "danger",
        });

        await new AcademicMovement()
          .getMovementReasons(this.studentsList[0].CODTIPOCURSO)
          .then(({ data }) => {
            this.movementReasons = Array.isArray(data) ? data : [data];
          })
          .catch(({ error }) => {
            this.error = error;
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      }
    },

    async executeTransfer() {
      this.error = false;
      this.message = "";

      if (this.studentsToTransfer.length > this.destinationSelected.NUMVAGAS) {
        this.error = true;
        this.message = "Erro: não há vagas suficientes na turma de destino.";
        return;
      }

      this.studentsToTransferResult = [];

      let disciplineToTransfer = [];
      disciplineToTransfer.push({
        originSubjectId: this.originSubjectId,
        destinySubjectId: this.destinationSelected.IDTURMADISC,
      });

      this.$vs.loading({
        color: "danger",
      });

      for (let student of this.studentsToTransfer) {
        let payload = {
          colligateId: student.CODCOLIGADA,
          originQualificationId: student.IDHABILITACAOFILIAL,
          destinyQualiticationId: student.IDHABILITACAOFILIAL,
          ra: student.RA,
          reasonId: this.movementReasonSelected,
          sameBranchAndShift: 1,
          originSchoolYearId: student.IDPERLET,
        };
        payload.disciplines = disciplineToTransfer;

        await new AcademicMovement()
          .executeTransferProcess(payload)
          .then((result) => {
            console.log(result);
            student.result = "Transferência Ok";
          })
          .catch((error) => {
            console.log(error);
            student.result = "Erro: não foi possível realizar a transferência";
            student.class = "errorProcess";
          });
        this.studentsToTransferResult.push(student);
      }

      this.originSubjectId = null;
      this.studentsToTransfer = [];
      this.$vs.loading.close();
      this.destinationSelected = null;
      this.destinationOptions = [];
      this.studentsList = [];
      this.hasStudents = false;
      this.resultProcess = true;
    },
  },
};
</script>
<style scoped>
.small {
  font-size: smaller;
  color: #666;
}
.error {
  padding: 3%;
  color: red;
}
.errorProcess {
  color: red;
}
</style>
